"use client";

import { CheckCircle, FileText, TrendingUp } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function HowItWorks() {
  const {
    ref: ref1,
    isVisible: isVisible1
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: ref2,
    isVisible: isVisible2
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: ref3,
    isVisible: isVisible3
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const steps = [{
    number: "01",
    icon: FileText,
    title: "Connect Your Accounts",
    description: "Seamlessly integrate your bank accounts, invoices, and financial data into one secure cloud platform. Our automated sync keeps everything up-to-date in real-time."
  }, {
    number: "02",
    icon: CheckCircle,
    title: "Smart Categorization",
    description: "Our intelligent system automatically categorizes transactions, receipts, and expenses. You can review and approve with just a few clicks."
  }, {
    number: "03",
    icon: TrendingUp,
    title: "Track & Optimize",
    description: "Access comprehensive reports, forecasts, and insights anytime, anywhere. Make informed decisions with real-time financial visibility."
  }];
  const refs = [ref1, ref2, ref3];
  const visibilities = [isVisible1, isVisible2, isVisible3];
  return <section id="how-it-works" className="py-24 md:py-32 bg-background">
      <div className="container mx-auto px-6 md:px-8 max-w-7xl">
        <div className="text-center mb-16">
          <h2 className="text-[48px] leading-[1.2] font-bold tracking-[-0.2px] text-foreground mb-4">
            How It Works
          </h2>
          <p className="text-[16px] leading-[1.6] text-muted-foreground max-w-2xl mx-auto">
            Cloud solutions are the future for bookkeeping. Get started in three simple steps and experience modern financial management.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
          {steps.map((step, i) => {
          const Icon = step.icon;
          return <div key={i} data-index={i} ref={refs[i]} className={`transition-all duration-700 ease-out ${visibilities[i] ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} style={{
            transitionDelay: `${i * 150}ms`
          }}>
                <Card className="relative overflow-hidden h-full group hover:bg-accent-light/30 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)]">
                  <div className="absolute top-4 right-4 text-[120px] leading-none font-bold text-foreground select-none pointer-events-none">
                    {step.number}
                  </div>
                  
                  <CardHeader className="relative z-10 pt-8">
                    <div className="mb-6 inline-flex">
                      <div className="p-4 rounded-[var(--radius-md)] bg-primary text-foreground-primary shadow-soft group-hover:shadow-medium transition-all duration-[var(--duration-medium)]">
                        <Icon className="w-8 h-8" />
                      </div>
                    </div>
                    <CardTitle className="text-[28px] leading-[1.4] font-semibold tracking-[-0.2px]">
                      {step.title}
                    </CardTitle>
                  </CardHeader>
                  
                  <CardContent className="relative z-10">
                    <CardDescription className="text-[16px] leading-[1.6] text-muted-foreground">
                      {step.description}
                    </CardDescription>
                  </CardContent>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}